/**
 * 商品検索用VOクラス
 */
export class GetCWSPlanGoodsSearchModel {
  //  共通
  /**  カテゴリ区分 */
  public categoryDiv = String('');
  /**  受注コード */
  public orderCode = String('');
  /**  ページ番号 */
  public pageNo: number;
  /**  ソートキー */
  public sortKey = String('');
  /**  ソート順 */
  public sortOrder = String('');
  /**  在庫限定フラグ */
  public stockLimitFlg = String('');

  // 通常検索タブ
  /**  Ｐコード */
  public pcode = String('');
  /** アイテムコード */
  public itemCode = String('');
  /** JANコード */
  public janCode = String('');
  /** メーカ名 */
  public makerName = String('');
  /** 商品案内用商品名 */
  public guideGoodsNameList: Array<any> = [];
  /** 商品案内用規格名 */
  public guideStandardNameList: Array<any> = [];
  /** 発注先コード */
  public ordrClientCode = String('');
  /** 発注先名称 */
  public ordrClientKanji = String('');
  /** 支払先コード */
  public payeeClientCode = String('');
  /** 支払先名称 */
  public payeeClientKanji = String('');
  /** 部門コード */
  public classCode = String('');
  /** 中分類コード */
  public middleClassCode = String('');
  /** 小分類コード */
  public smallClassCode = String('');
  /** 商品マスタ登録日From */
  public registDateFrom = String('');
  /** 商品マスタ登録日To */
  public registDateTo = String('');
  /** 商品マスタ更新日From */
  public updateDateFrom = String('');
  /** 商品マスタ更新日To */
  public updateDateTo = String('');
  /** 生協コード */
  public coopCodeList: Array<any> = [];
  /** 登録レベル */
  public admitStatus = String('');
  /** バイヤーコード */
  public buyerCode = String('');
  /** タグID */
  public tagIdList: Array<any> = [];
  /** タグ検索方法 */
  public tagSearchType = String('');
  /** マークコード */
  public goodsMarkList: Array<any> = [];
  /** 商品マーク検索方法 */
  public goodsMarkSearchType = String('');
  /** 業態区分（デイリー） */
  public dutiesList: Array<any> = [];
  /** 取扱終了商品を含む */
  public dataKbnFlg: boolean = false;
  /** 商品区分(空文字:全ての商品、1:ダミー商品) */
  public goodsDiv = String('');
  /** 商品検索媒体区分 */
  public searchMediumType = String('');
  /** 商品検索受注コード */
  public searchOrderCode = String('');
  /** 特集コード */
  public specialFeature = String('');
  /** 企画マーク */
  public catalogCodeList: Array<any> = [];
  /** 企画マーク検索方法 */
  public catalogCodeSearchType = String('');
  /** ページNo */
  public pageNoList: Array<any> = [];
  // リスト検索タブ
  /** Ｐコードリスト */
  public pcodeList: Array<any> = [];
   /** アイテムコードリスト */
  public itemCodeList: Array<any> = [];

}
